import React, { useEffect, useState } from "react";
import StepOneProgress from "../../../../assets/images/brand-steps-progress-indicator/step-one.svg";
import Proptypes from "prop-types";
import styles from "./addbrand.module.scss";
import Button from "../../../Shared/Button";
import Textfield from "../../../Shared/Textfield";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { GetCountries, GetState } from "react-country-state-city";

const StepOne = ({ setStep, toggle, handleChange, formik }) => {
  const [countriesList, setCountriesList] = useState([
    {
      id: 233,
      name: "United States",
      iso3: "USA",
      iso2: "US",
      numeric_code: "840",
      phone_code: "1",
      capital: "Washington",
      currency: "USD",
      currency_name: "United States dollar",
      currency_symbol: "$",
      tld: ".us",
      native: "United States",
      region: "Americas",
      subregion: "Northern America",
      latitude: "38.00000000",
      longitude: "-97.00000000",
      emoji: "🇺🇸",
    },
  ]);
  const [stateList, setStateList] = useState([]);
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [stateDropdown, setStateDropdown] = useState(false);

  const countryValue =
    formik?.values?.country?.length > 25
      ? formik?.values?.country?.slice(0, 25) + "..."
      : formik?.values?.country;
  const stateValue =
    formik?.values?.state?.length > 25
      ? formik?.values?.state?.slice(0, 25) + "..."
      : formik?.values?.state;

  useEffect(() => {
    GetCountries().then((result) => {
      setCountriesList(result);
    });
  }, []);

  useEffect(() => {
    GetState(233).then((result) => {
      setStateList(result);
    });
  }, []);

  return (
    <>
      <div className={styles["progress_container"]}>
        <div className={styles["progress_container_indicator"]}>
          <img src={StepOneProgress} width={232} height={42} alt="progress" />
        </div>
      </div>
      <div>
        <p className={styles["heading_container"]}>Add Brand</p>
      </div>
      <div style={{ marginBottom: "19px" }}>
        <p className={styles["description_container"]}>
          Let's get a little bit of info on the Brand (* indicates that it can
          not be changed later)
        </p>
      </div>
      <div className={styles["namebrandfields"]}>
        <div className={styles["inputFieldsDiv"]}>
          <Textfield
            value={formik.values.brandName}
            error={formik.errors.brandName}
            touched={formik.touched.brandName}
            handleBlur={formik.handleBlur}
            name="brandName"
            id="brandName"
            onChange={handleChange}
            type="text"
            placeholder="Brand name"
            className={styles["input_field_styles"]}
          />
        </div>
        <div className={styles["inputFieldsDiv"]}>
          <Textfield
            value={formik.values.parentCompany}
            error={formik.errors.parentCompany}
            touched={formik.touched.parentCompany}
            handleBlur={formik.handleBlur}
            name="parentCompany"
            id="parentCompany"
            onChange={handleChange}
            placeholder="Parent company"
            className={`${styles["input_field_styles"]} ${styles["info_icon_field"]}`}
          />
        </div>
      </div>
      <div className={styles["namebrandfields"]}>
        <div className={styles["inputFieldsDiv"]}>
          <Textfield
            value={formik.values.businessEntityName}
            error={formik.errors.businessEntityName}
            touched={formik.touched.businessEntityName}
            handleBlur={formik.handleBlur}
            name="businessEntityName"
            id="businessEntityName"
            onChange={handleChange}
            type="text"
            placeholder="Business entity name"
            className={`${styles["input_field_styles"]} ${styles["info_icon_field"]}`}
          />
        </div>
        <div className={styles["inputFieldsDiv"]}>
          <Textfield
            value={formik.values.businessRegistrationNumber}
            error={formik.errors.businessRegistrationNumber}
            touched={formik.touched.businessRegistrationNumber}
            handleBlur={formik.handleBlur}
            name="businessRegistrationNumber"
            id="businessRegistrationNumber"
            onChange={handleChange}
            placeholder="Business registration number"
            className={`${styles["input_field_styles"]} ${styles["info_icon_field"]}`}
          />
        </div>
      </div>

      <div>
        <p className={styles["addressHeading"]}>Address</p>
      </div>
      <div className={styles["address_fields"]}>
        <div className={styles["addressfielddiv"]}>
          <div className={styles["inputFieldsDiv"]}>
            <Textfield
              value={formik.values.addressLine1}
              error={formik.errors.addressLine1}
              touched={formik.touched.addressLine1}
              handleBlur={formik.handleBlur}
              name="addressLine1"
              id="addressLine1"
              onChange={handleChange}
              type="text"
              placeholder="Address Line 1"
              className={styles["input_field_styles"]}
            />
          </div>
          <div className={styles["inputFieldsDiv"]}>
            <Textfield
              value={formik.values.addressLine2}
              error={formik.errors.addressLine2}
              touched={formik.touched.addressLine2}
              handleBlur={formik.handleBlur}
              name="addressLine2"
              id="addressLine2"
              onChange={handleChange}
              placeholder="Address Line 2"
              className={styles["input_field_styles"]}
            />
          </div>
        </div>
        <div className={styles["addressfielddiv"]}>
          <div className={styles["inputFieldsDiv"]}>
            <Dropdown
              isOpen={countryDropdownOpen}
              toggle={() => {
                setCountryDropdownOpen(!countryDropdownOpen);
              }}
              disabled
            >
              <DropdownToggle
                className={`${styles["input_field_styles"]} ${styles["brand_dropdown"]}`}
              >
                {countryValue || "Country"}
              </DropdownToggle>
              <DropdownMenu className={styles["menu_dropdown"]}>
                {(countriesList || [])?.map((country, index) => {
                  return (
                    <DropdownItem
                      className={styles["dropdown_item"]}
                      onClick={() => {
                        formik.setFieldValue("country", country.name);
                        formik.setFieldValue("state", "");
                        GetState(country.id)
                          .then((result) => {
                            setStateList(result);
                          })
                          .catch((error) => {
                            console.error("Error fetching states:", error);
                          });
                      }}
                      key={index}
                    >
                      <div>{country?.name || ""}</div>
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
            {formik?.errors?.country && formik?.touched?.country && (
              <div className={styles["error"]}>{formik?.errors?.country}</div>
            )}
          </div>
          <div className={styles["inputFieldsDiv"]}>
            <Textfield
              value={formik.values.city}
              error={formik.errors.city}
              touched={formik.touched.city}
              handleBlur={formik.handleBlur}
              name="city"
              id="city"
              onChange={handleChange}
              placeholder="City"
              className={styles["input_field_styles"]}
            />
          </div>
        </div>
        <div className={styles["addressfielddiv"]}>
          <div className={styles["inputFieldsDiv"]}>
            <Dropdown
              isOpen={stateDropdown}
              toggle={() => {
                setStateDropdown(!stateDropdown);
              }}
            >
              <DropdownToggle
                className={`${styles["input_field_styles"]} ${styles["brand_dropdown"]}`}
              >
                {stateValue || "State"}
              </DropdownToggle>
              <DropdownMenu className={styles["menu_dropdown"]}>
                {(stateList || [])?.map((state, index) => {
                  return (
                    <DropdownItem
                      className={styles["dropdown_item"]}
                      onClick={() => {
                        formik.setFieldValue("state", state?.name);
                      }}
                      key={index}
                    >
                      <div>{state?.name || ""}</div>
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </Dropdown>

            {formik?.errors?.state && (
              <p className={styles["error"]}>This field is Required!</p>
            )}
          </div>
          <div className={styles["inputFieldsDiv"]}>
            <Textfield
              value={formik.values.zipCode}
              error={formik.errors.zipCode}
              touched={formik.touched.zipCode}
              handleBlur={formik.handleBlur}
              name="zipCode"
              id="zipCode"
              onChange={handleChange}
              placeholder="Zip Code"
              className={styles["input_field_styles"]}
            />
          </div>
        </div>
      </div>

      <div className={styles["submit_btns"]}>
        <div className={styles["button_div"]}>
          <Button
            className={styles["button_style_cancel"]}
            onClick={() => {
              toggle();
            }}
            text="Cancel"
          />
        </div>
        <div className={styles["button_div"]}>
          <Button
            className={styles["button_style_add"]}
            onClick={() => {
              if (formik.isValid && formik.dirty) {
                setStep(1);
              } else {
                formik.setTouched({
                  brandName: true,
                  parentCompany: true,
                  businessEntityName: true,
                  businessRegistrationNumber: true,
                  addressLine1: true,
                  // country: true,
                  city: true,
                  state: true,
                  zipCode: true,
                });
              }
            }}
            text="Next"
          />
        </div>
      </div>
    </>
  );
};
StepOne.propTypes = {
  setStep: Proptypes.func,
  toggle: Proptypes.func,
  handleChange: Proptypes.func,
  formik: Proptypes.object,
};
export default StepOne;
